"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isUndefined = require('lodash/isUndefined');

function getNext(object, nextSetting) {
  var def;

  if (Object.keys(nextSetting).length > 1) {
    if (Object.keys(nextSetting).length === 2 && Object.keys(nextSetting).includes('default')) {
      def = nextSetting["default"];
    } else {
      // console.error(
      throw new Error('A decision tree can only parse one key at a time,', 'and will always pick the first key.\n\n', 'Make sure you have properly structured your decision tree.', nextSetting, object);
    }
  }

  var nextKey = Object.keys(nextSetting).filter(function (key) {
    return key !== 'default';
  })[0];
  var val = object[nextKey] == null ? 'false' : object[nextKey].toString(); // if the key is a RegExp, like /Shimmer/, use RegExp to find the desired path

  if (!isUndefined(val)) {
    if (nextSetting[nextKey][val]) {
      return nextSetting[nextKey][val];
    } // if it doesnt match exactly, we need to check
    // for Regular Expression keys.
    // if val is 'White Shimmer', and the next
    // key is /Shimmer/, we actually want to get
    // all the next level's keys,
    // turn them into regular expressions,
    // and then see if one matches.


    var valFromRegExp; // this lets us use !<Double Thick> to mean
    // "does not match /Double Thick/"

    var keys = Object.keys(nextSetting[nextKey]);

    for (var i = 0; i < keys.length; i++) {
      // key could be <Shimmer> or <Matte>, etc.
      var key = keys[i];
      var newKey = key;

      var condition = function condition(v) {
        return v;
      }; // in the decision tree, we are allowing the use of
      // RegExp keys using < & > instead of / & / because
      // "/" is reserved for path separations.
      // We're also allowing the key to start with "!" to
      // represent "does not match"


      var matcher = /(.*)<([A-Za-z ]+)>([a-z]*)/;

      if (key.match(matcher)) {
        var matchers = key.match(matcher);

        if (matchers[1] && matchers[1] === '!') {
          condition = function condition(v) {
            return !v;
          };
        }

        newKey = new RegExp(matchers[2], matchers[3]);
      } // if nextKey is "paper_type" and newKey is "<Matte>"
      // and val is "White Matte", we want valFromRegExp to be "<Matte>".
      // This will get us to return nextSetting.paper_type["<Matte>"] (below)
      // to continue down the decision tree.
      // In other words, if the value matches the key when represented as
      // a Regexp, the next JSON key is not the value ("White Matte"),
      // but the matcher ("<Matte>").


      try {
        if (condition(val.match(newKey))) {
          valFromRegExp = key;
          break;
        }
      } catch (error) {
        console.error(val);
        throw new Error(error);
      }
    }

    if (valFromRegExp) {
      return nextSetting[nextKey][valFromRegExp];
    }

    if (def) {
      return def;
    }
  }

  return false; // throw new Error(`A setting for ${nextKey}:${val} was not found`);
}
/**
 * traverseDecisionTree takes a (JSON) decision tree and returns
 * the first string based on the parameters in the object.
 * @memberof ShinePrinting/Helpers
 * @param {Object} object - the key-value pairs
 * @param {Object} tree - the decision logic
 * @example
 * const tree = {
 *     'double_envelopes': {
 *         true: {
 *             'name_printing': {
 *                 true: '-NamePrinting',
 *                 false: '-Blank Envelopes'
 *             }
 *         }
 *         false: {
 *             'guest_addressing': {
 *                 true: '-GuestAddressing',
 *                 false: {
 *                     'return_addressing': {
 *                         true: '-InvitationEnvelope'
 *                         false: '-Blank Envelopes'
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * }
 * traverseDecisionTree({ double_envelopes: true, name_printing: false }, tree) // => '-Blank Envelopes'
 * traverseDecisionTree({ double_envelopes: true, name_printing: true }, tree)  // => '-NamePrinting'
 */


function traverseDecisionTree(object, tree) {
  if (Object.prototype.toString.call(tree) !== '[object Object]') {
    return tree;
  }

  var nextSetting = _objectSpread({}, tree); // this will return the first non-object found in the decision tree.


  while (Object.prototype.toString.call(nextSetting) === '[object Object]') {
    nextSetting = getNext(object, nextSetting);
  }

  return nextSetting;
}

module.exports = traverseDecisionTree;